import { render, staticRenderFns } from "./ClientsReportsForm.vue?vue&type=template&id=9b1722b8&"
import script from "./ClientsReportsForm.vue?vue&type=script&lang=js&"
export * from "./ClientsReportsForm.vue?vue&type=script&lang=js&"
import style0 from "./ClientsReportsForm.vue?vue&type=style&index=0&id=9b1722b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports